// extracted by mini-css-extract-plugin
export var container = "services-module--container--spgoP";
export var dataEngCardTitle = "services-module--dataEngCardTitle--pVYip";
export var description = "services-module--description--icZwg";
export var description2 = "services-module--description2--3oPjl";
export var heading = "services-module--heading--HoXgY";
export var sectionHeading = "services-module--sectionHeading--aYFtx";
export var talentCard = "services-module--talentCard--Kml8R";
export var talentCardTitle = "services-module--talentCardTitle--ORaYQ";